module.exports = __webpack_public_path__ + "img/wechat.cea3dad0.png";